import { call, put, takeEvery, select } from 'redux-saga/effects';
import * as t from '../../../../actionTypes.js';
import actions from '../../../../actions/index.js';
import checkLicenceApi from '../../../apiCalls/checkLicenceApi.js';
import checkVstLicenceApi from '../../../apiCalls/checkVstLicenceApi.js';
import addActivationCodeApi from '../../../apiCalls/users/addActivationCode.api.js';
import addVSTActivationCodeApi from '../../../apiCalls/users/addVSTActivationCode.api.js';
import { getCurrentPlatform } from '../../../../../utils/platform.js';
import getLocalStorageTempClientId from '../../../utils/clientId.js';
import appSettings from '../../../../../globals/appSettings.js';

function* validateAccessCode({ accessCode, reCAPTCHAToken = null, source = 'EPS' }) {
  const platform = getCurrentPlatform();
  const payload = {
    activationCode: accessCode,
  };

  if (reCAPTCHAToken) {
    payload.reCAPTCHAToken = reCAPTCHAToken;
    payload.reCAPTCHATokenSource = platform;
  }

  const apiResults = yield (source === 'VST' ? checkVstLicenceApi : checkLicenceApi)({
    body: payload,
    headers: { tempClientId: getLocalStorageTempClientId(platform) },
  });

  if (apiResults.error || apiResults.status !== 'success') {
    const message = apiResults.message || '';
    const errorCodeMatch = message.match(/\d+/);
    const activationDateMatch = message.match(/\d{4}-\d{2}-\d{2}/);

    const error = {
      code: apiResults.code || errorCodeMatch?.[0] || 'UNKNOWN',
      activationDate: activationDateMatch?.[0],
    };

    yield put(actions.validateAccessCodeRequestFailure({ error }));
  } else {
    yield put(actions.validateAccessCodeRequestSuccess());
  }
}

function* redeemActivationCode({ accessCode, reCAPTCHAToken = null }) {
  const userId = yield select(state => state.identity.userId);
  try {
    const isVstCode = appSettings.ACCESS_CODE_VST_REGEX.test(accessCode);
    const payload = isVstCode
      ? {
        accessCode: accessCode.replace(/\s/g, ''),
          ...(reCAPTCHAToken && {
            reCAPTCHAToken,
            reCAPTCHATokenSource: getCurrentPlatform()
          })
        }
      : {
          userId,
          activationCode: accessCode
        };
    yield put(actions.validateAccessCodeStartRequest());
    const response = yield call(isVstCode ? addVSTActivationCodeApi : addActivationCodeApi, payload);

    if (response?.status === 'success') {
      yield put({ type: t.REDEEM_ACCESS_CODE_SUCCESS });
    } else {
      const match = response?.message?.match(/\[\[(\d+)\]\[(.+?)\]\]/);
      yield put({
        type: t.REDEEM_ACCESS_CODE_FAILURE,
        data: {
          error: {
            code: response?.code || match?.[1] || 'UNKNOWN',
            message: match?.[2] || response?.message || 'Unknown error occurred'
          }
        }
      });
    }
  } catch (error) {
    yield put({
      type: t.REDEEM_ACCESS_CODE_FAILURE,
      data: {
        error: {
          code: '500',
          message: error.message || 'Something went wrong'
        }
      }
    });
  }
}

export default function* index() {
  yield takeEvery(t.VALIDATE_ACCESS_CODE_REQUEST, ({ data }) => validateAccessCode(data));
  yield takeEvery(t.TRIGGER_REDEEM_ACTIVATION_CODE, ({ data }) => redeemActivationCode(data));
}
